import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import styles from './nextAvailable.scss';
import Popup from '../../../components/Popup';
import { CheckBox } from '../../../components/Form';
import { DoNotShowMatchStarted, generateLocalStorageKey } from '../../../utils/nextAvailable';
import { clearMatchPlacedPopupShowStatus } from '../../../actions/next-available-actions';

const MatchStartedPopup = (props) => {
    const { eventId } = props;
    const dispatch = useDispatch();
    const nextAvailable = useSelector(({ nextAvailable }) => nextAvailable);
    const auth = useSelector(({ auth }) => auth);

    const [doNotShowAgain, setDoNotShowAgain] = useState(false);

    const {
        matchStartedModal = {},
        courtsOfSelectedFacility = [],
    } = nextAvailable;

    const matchCourt = courtsOfSelectedFacility.find((court) => court.id === matchStartedModal?.match?.courtId);

    const onCloseStartConfirmPopup = () => {
        if (doNotShowAgain) {
            localStorage.setItem(generateLocalStorageKey(DoNotShowMatchStarted, eventId, auth), true);
        }

        dispatch(clearMatchPlacedPopupShowStatus());
    };

    const onChangeDoNotShowAgain = (value) => {
        setDoNotShowAgain(value);
    };

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.confirmPopup}
            onCloseClick={onCloseStartConfirmPopup}
            closeOnClickOutside={false}
            data-testid="modal.next-available.match-started"
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <h6 className={styles.title} data-testid="modal.next-available.match-started.title">
                Match started
            </h6>
            <p className={styles.description} data-testid="modal.next-available.match-started.description">
                {`Draw ${matchStartedModal?.match?.parentDrawName} match has been started on ${matchCourt?.name}. An SMS notification has been sent to the players.`}
            </p>
            <CheckBox
                controlled={true}
                id={`doNotShowAgain`}
                customLabel="Do not show me this modal again."
                checked={doNotShowAgain}
                onChange={onChangeDoNotShowAgain}
                data-testid="modal.next-available.match-started.do-not-show-checkbox"
            />
            <div className="d-flex mt16">
                <button
                    className="btn btn-default flex-1"
                    type="button"
                    onClick={onCloseStartConfirmPopup}
                    data-testid="modal.next-available.match-started.ok-btn"
                >
                    Ok
                </button>
            </div>
        </Popup>
    );
};

MatchStartedPopup.propTypes = {
   eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

MatchStartedPopup.defaultProps = {
};

export default MatchStartedPopup;
